import { render } from "./SystemSettingsPage.vue?vue&type=template&id=74ad95ed&ts=true"
import script from "./SystemSettingsPage.vue?vue&type=script&lang=ts"
export * from "./SystemSettingsPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__